module.exports = __webpack_public_path__ + "static/media/infoIcon-white.0249de63.png";